import React from 'react';
import LoginHeader from './LoginHeader';
import AdminLoginForm from './AdminLoginForm';
import SocialLogin from './SocialLogin';

function AdminLogin() {
  return (
    <div className="page-container login-popup">
      {/* <Navbar /> */}
      <div className="section-container">
        <div className="login-content">
          <div className="login-main">
            <LoginHeader />
            <AdminLoginForm />
            <SocialLogin />
          </div>
        </div>
        <img
          className="login-image"
          loading="lazy"
          src="./sam.jpg"
          alt="Login illustration"
        />
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default AdminLogin;